export default "__VITE_ASSET__CZGdK1T$__"